import { translate as t } from '@thoughtspot/i18n';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { Vertical } from "../../../../utils/layouts";
import { dataColumnsClusterDetails, prepareTableRowDataClusterDetails, } from '../cluster-status-utils';
import styles from './cluster-details-tables.module.scss';
export const ClusterDetailsTable = ({ statsData, clusterInfoData, }) => {
    const tableRowData = prepareTableRowDataClusterDetails(statsData, clusterInfoData);
    const renderContent = () => (React.createElement(Vertical, { className: styles.table, "data-testid": "cluster-details-table-id" },
        React.createElement(Typography, { variant: "h4", color: Colors.base, noMargin: true }, t('adminUI.messages.CLUSTER_DETAIL_INFO_TITLE')),
        React.createElement(Table, { className: styles.tableComponent, data: tableRowData, columns: dataColumnsClusterDetails }),
        tableRowData && (React.createElement(Horizontal, { className: styles.tableFooter },
            React.createElement(Typography, { variant: "body-normal" }, t('pagination_footer', {
                total: '10',
            }))))));
    return renderContent();
};
//# sourceMappingURL=cluster-details.container.js.map